<template>
  <hr class="field-line"/>
</template>

 <script>
  export default {
    name: 'form-field-line'
  }
</script>

<style lang="scss" scoped>
  .field-line {
    border: none;
    border-bottom: 1px dashed #C2CCCE;
    margin: 14px 0;
    display: flex;
    flex: 100%;

    + .field-holder {
      margin-top: 10px;
    }
  }
</style>
